import { attr } from 'spraypaint';
import stringOrNullAttr from '../stringOrNullAttr';
import ApplicationRecord from './ApplicationRecord';

const Authorization = ApplicationRecord.extend({
  attrs: {
    client_id: stringOrNullAttr(),
    code: attr({ persist: false }),
    code_challenge: stringOrNullAttr(),
    code_challenge_method: stringOrNullAttr(),
    redirect_uri: stringOrNullAttr(),
    response_type: stringOrNullAttr(),
    scope: stringOrNullAttr(),
    state: stringOrNullAttr(),
  },
  static: {
    endpoint: '/authorizations',
    jsonapiType: 'vitality_oauth-authorizations',
  },
});

export default Authorization;
